import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { Ranking } from '../interfaces/ranking';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RankingDataService {

  constructor(
    private http: HttpClient
  ) { }

  private urlRanking = environment.urlWebServices + '/cwk/ranking';

  // Read rankings
  read(): Observable<Ranking[]> {
    return this.http.get<Ranking[]>(this.urlRanking);
  }
}
